
import { onMounted, ref, reactive, nextTick, watch } from 'vue'
import { dotWebReady, receiveDotAnswer, resetCountTime, writeLog, sensorsAnaticEvent } from "@/utils/nativeFn";
import { registerFnHandler } from '@/utils/registerFnHandler'
import store from '@/store/index'
import DotQue from "@/components/Aio/DotQue.vue"
import WrongPage from "@/components/WrongPage.vue";
import LoadingPage from "@/components/LoadingInDot.vue";
import quesList from './question'
import Scrollbar from 'smooth-scrollbar';
export default {
    name: 'TaskDot',
    components: {
        DotQue,
        WrongPage,
        LoadingPage,
    },
    setup() {
        interface IInteractQue {
            "question_type": number; //类型：Number  必有字段  备注：题目类型 1单选 2多选 3多选多
            "source": number; //类型：Number  必有字段  备注：来源 2-自编 1-内容云
            "question_id": string; //类型：String  必有字段  备注：题目id
            "question_info": object;
        }
        interface IDotTile {
            'dot_start_time': number; //类型：Number  必有字段  备注：打点时间点 毫秒
            'answer_type': number; //类型：Number  必有字段  备注：答题类型 1-全封闭 2-半封闭
            'interact_type': string; //类型：String  必有字段  备注：互动形式 1题 2 试卷 3其它
            'interact_question_cfg': IInteractQue[]
            isLoaded: boolean;
            isCurrent: boolean;
        }
        type IInteractDot = Omit<IDotTile, 'isLoaded' | 'isCurrent'>
        interface IInteractData {
            'video_dot':  IInteractDot; // 单个视频打点数据
            'video_index': string;  // 数据索引 ，从0开始递增1
        }
        interface IInteractPostion {
            'video_dot'?:  IInteractDot; // 单个视频打点数据
            'position': string;  // 数据索引 
        }
        const loading = ref(true)
        const entryTime = ref(0)
        const unionid = ref('')
        const videoTitle = ref('')
        const answerSign = ref('')
        const scrollbar = ref(null)
        let refCurrentBox = ref(null)
        let refMainCon = ref(null)
        let dotScrollHeight = ref(0) // 滚动条高度
        let answerMap = {} // 所有学生做答答案map key为题目id
        let judgeMap = {} // 所有判题结果map key为题目id
        let questionsMap = {} // 所有问题的map 用于判断
        let queResList = [] // 存放当前打点试题结果
        let noAnswerType = ref('0') // 不答题关闭类型
        const isAfterSubmit = ref(false)
        const refQueBox = ref(null)
        const curTime = ref(0)

        const startTime = ref(0)
        const startX = ref(0)
        const startY = ref(0)
        let dotMap = reactive({
            // '0':            //类型：Array  必有字段  备注：无
            //   {                //类型：Object  必有字段  备注：无
            //     "dot_start_time":3000,                //类型：Number  必有字段  备注：打点时间点 毫秒
            //     "answer_type":1,                //类型：Number  必有字段  备注：答题类型 1-全封闭 2-半封闭
            //     "interact_type":"1",                //类型：String  必有字段  备注：互动形式 1题 2 试卷 3其它
            //     "interact_question_cfg": [                //类型：Array  必有字段  备注：题
            //           {                //类型：Object  必有字段  备注：无
            //             "question_type":1,                //类型：Number  必有字段  备注：题目类型 1单选 2多选 3多选多
            //             "question_type_msg":"mock",                //类型：String  必有字段  备注：question_type 的中文 选择题
            //             "source":1,                //类型：Number  必有字段  备注：来源 2-自编 1-内容云
            //             "question_id":quesList[0].queId,                //类型：String  必有字段  备注：题目id
            //             "question_info": quesList[0],
            //         },
            //           {                //类型：Object  必有字段  备注：无
            //             "question_type":1,                //类型：Number  必有字段  备注：题目类型 1单选 2多选 3多选多
            //             "question_type_msg":"mock",                //类型：String  必有字段  备注：question_type 的中文 选择题
            //             "source":1,                //类型：Number  必有字段  备注：来源 2-自编 1-内容云
            //             "question_id":quesList[1].queId,                //类型：String  必有字段  备注：题目id
            //             "question_info": quesList[1],
            //         }
            //     ],
            //     isLoaded: true
            // }
        } as {[attrName: string]: any}) // 存储所有的点的信息
        const dotUnloadedList = ref([]) // 没被加载的点的时间数组 与dotMap中的key对应
        let loadQueTimer = null
        const currentIndex = ref('0')
        const resetStatus = () => {
            if (refQueBox.value) {
                refQueBox.value.scrollTop = 0
            }

            scrollbar.value && scrollbar.value.scrollTo(0, 0, 0)
            entryTime.value = new Date().getTime()
            curTime.value = new Date().getTime()
            isAfterSubmit.value = false
            answerMap = {} // 所有学生做答答案map key为题目id
            judgeMap = {} // 所有判题结果map key为题目id
            questionsMap = {} // 所有问题的map 用于判断
            queResList = [] // 存放当前打点试题结果
        }
        // 将打点信息放到dotMap
        const setDotMap = (data, isCurrent = false) => {
            let { video_dot: videoDot, video_index: dotIndex, position: curIndex, unionid: video_unionid='', title='', answer_sign = '', watch_order = '' } = data
            videoDot = JSON.parse(videoDot)
            // (JSON.stringify(videoDot.interact_question_cfg[0].question_info))
            dotIndex = isCurrent ? curIndex : dotIndex
            if (!dotMap[dotIndex]) {
                Object.assign(dotMap, { [`${dotIndex}`]: { ...videoDot, isLoaded: isCurrent} })
            } else if (dotMap[dotIndex] && !dotMap[dotIndex].isLoaded) {
                dotUnloadedList.value = (dotUnloadedList.value || []).filter(item => item !== dotIndex)
                loadQue(dotMap[dotIndex].interact_question_cfg, dotIndex)
            }
            if (isCurrent) {
                resetStatus()
                unionid.value = video_unionid
                videoTitle.value = title
                currentIndex.value = dotIndex + ''
                answerSign.value = answer_sign || watch_order
                initQuestionsMap()
                sensorsAnaticEvent('show_interact_test', {
                    event_name: '出现:互动题',
                    event_type: 'show',
                    page_name: 'video_view',
                    answer_sign: answerSign.value,
                    video_id: unionid.value,
                    video_name: videoTitle.value,
                    request_type: videoDot.answer_type + '', // 答题类型
                    test_type: ((videoDot?.interact_question_cfg || []).map(item => item.question_type)).join(','), // 题目类型
                    que_ids: ((dotMap?.[currentIndex.value]?.interact_question_cfg || []).map(item => item.question_id)).join(','),
                })
            }
        }
        // 加载题目
        const loadQue = (data: IInteractQue[], dotIndex) => {
            nextTick(() => {
                // 变更dotMap中的加载状态
                Object.assign(dotMap, { [`${dotIndex}`]: { ...dotMap[dotIndex], isLoaded: true, }})
            })
        }
        // 当前题目加载完毕
        const handleAfterRender = (dotIndex) => {
            loading.value = false
            entryTime.value = new Date().getTime()
            nextTick(() => {
                if (!scrollbar.value) {
                    scrollbar.value = Scrollbar.init(refCurrentBox.value, {
                        alwaysShowTracks: true,
                        damping: 0.15,
                        plugins: {
                            effect: 'glow',
                        },
                    });
                } else {
                    scrollbar.value.scrollTo(0, 0, 0)
                }
                
            })
            // 题目加载完成日志
            writeLog({
                log_content: {
                    label: 'handleAfterRender',
                    dotIndex,
                    time: new Date().getTime()
                }
            })
        }
        const handlePagerChange = (data) => {
            data?.queId && Object.assign(answerMap, {[data.queId]: data.data})
            handleSubmit()
        }
        // 初始化questionsMap（以题目id为key）并计算总分数
        const initQuestionsMap = () => {
            let _questionsMap = {};
            (dotMap?.[currentIndex.value]?.interact_question_cfg || []).forEach((tile, index) => {
                let item = tile.question_info
                queResList[index] = {}
                if (item.logicQuesTypeId === '9' && item?.childList?.length) {
                    // 复合题
                    queResList[index] = {
                        isRight: true,
                        queId: item.queId,
                        index,
                        childList: []
                    }
                    item.childList.forEach((tile, key) => {
                        let { queId, logicQuesTypeId, isDecidable } = tile
                        window['TalqsInteraction']?.removeData(queId)
                        _questionsMap[queId] = {
                            rootId: item.queId,
                            queId: queId,
                            index,
                            subIndex: key,
                            type: logicQuesTypeId,
                            isDecidable,
                            queData: tile,
                            source: tile.source
                        }
                        queResList[index].childList.push(queId)
                    })
                } else {
                    let { queId, logicQuesTypeId, isDecidable } = item
                    window['TalqsInteraction']?.removeData(queId)
                    _questionsMap[queId] = {
                        rootId: queId,
                        queId: queId,
                        source: tile.source,
                        index,
                        type: logicQuesTypeId,
                        isDecidable,
                        queData: item,
                    }
                    queResList[index] = {
                        isRight: true,
                        queId: queId,
                        index,
                        childList: null
                    }
                }
            })
            Object.assign(questionsMap, _questionsMap)
        }
        const verifyRequired = () => {
            let  blankArr = [] // 用户组装未填写的题号
            Object.keys(questionsMap).forEach(item => {
                // 可交互的题完全没做答或者部分没做答均算作未做答
                if ((!answerMap[item] && questionsMap[item].isDecidable === 1) || answerMap?.[item]?.some(item => item === '')) {
                    !blankArr.includes(questionsMap[item]?.index + 1) && blankArr.push(questionsMap[item]?.index + 1)
                }
            })
            return blankArr.join('、')
        }
        const makeResultAnswerPartial = (judgeRes) => {
            judgeRes.forEach(item => {
                if (item?.[0]?.queId) {
                    judgeMap[item[0].queId] = item[0].judge
                }
            })
        }
        const makeResult = (judgeRes) => {
            judgeRes.forEach(item => {
                if (item?.[0]?.queId) {
                    judgeMap[item[0].queId] = item[0].judge
                }
            })
            let _queSumScore = 0
            let _stuSumScore = 0
            let submitObj = {}
            Object.keys(questionsMap).forEach(item => {
                let stuScore = 0
                let ansRes = 1 // 不能判题默认正确
                // 按填对的题数计算正确率
                let queScore = 0
                let { rootId, type, queId } = questionsMap[item]
                if (questionsMap[item].isDecidable === 1) {
                    // 可判题
                    let tmpLen = (judgeMap[item] || []).filter(tile => tile === 1).length
                    stuScore = tmpLen
                    queScore = judgeMap[item].length
                } else {
                    // 不可判题默认正确
                    stuScore = answerMap[item]?.length || 1
                    queScore = stuScore

                }
                ansRes = stuScore === queScore ? 1 : 0
                if ((questionsMap?.[item]?.index || questionsMap?.[item]?.index === 0) && queResList?.[questionsMap?.[item]?.index]) {
                    queResList[questionsMap[item].index].isRight = !!ansRes
                }
                submitObj[item] = {
                    rootId,
                    queId,
                    queScore,
                    type,
                    stuScore,
                    data: answerMap[item] || [''],
                    judge: judgeMap[item] || [1],
                    ansRes,
                    source: questionsMap[item].source,
                }
                _stuSumScore += stuScore
                _queSumScore += queScore
            })
            return {
                stuSumScore: _stuSumScore,
                queSumScore: _queSumScore,
                submitObj
            }
        }
        // 提交答案
        const handleSubmit = (type='') => {
            if (type === '') {
                resetCountTime()
                let requiredErrMsg = verifyRequired()
                if (requiredErrMsg) {
                    return
                } else {
                    noAnswerType.value = '0'
                }
                isAfterSubmit.value = true
            }
            const judgeRes = (Object.keys(questionsMap || {}) || []).filter(item => questionsMap[item].isDecidable === 1).map((item) => {
                let tile = questionsMap[item].queData
                let answerData = {
                    "queId": tile.queId,
                    "rigAnswer": tile.normalAnswer,
                    "type": tile.logicQuesTypeId,
                    "gradeGroupId": tile.gradeGroupId,
                    "subjectId": tile.subjectId,
                    "stuAnswer": answerMap[item]
                }
                return window?.['judge'](answerData, store.getters.talqsInteractionConfig, { halfRight: 'true', content: false }) || {}
            })
            if (type === '') {// console.log(judgeRes)
                // console.log(judgeRes, '===========judgeRes============')
                let { stuSumScore, queSumScore, submitObj} = makeResult(judgeRes)
                let { answer_type, dot_start_time,  interact_type, paper_id = '' } = dotMap?.[currentIndex.value] || {}
                let data = {
                    unionid: unionid.value,
                    answer_type,
                    dot_start_time,
                    interact_type,
                    paper_id,
                    answer_sign: answerSign.value,
                    'ans_duration': Math.round((new Date().getTime() - entryTime.value) / 1000), // 作答时长(秒)
                    answer: Object.keys(submitObj).map(item => submitObj[item])
                }
                let answerStatus = queSumScore > stuSumScore ? 0 : 1
                let resMap = {
                    data,
                    answer_status: answerStatus,
                    right_answer: (queResList.map(item => {
                        return answerStatus ? '你答对了！' : `正确答案 ${questionsMap?.[item.queId]?.queData?.normalAnswer?.join('、') || ''}`
                    })).join(';')
                }
                receiveDotAnswer(resMap, () => {
                    console.log('提交作答结果成功')
                })

                // 提交作答结果日志
                writeLog({
                    log_content: {
                        label: 'handleSubmit',
                        resMap,
                        dotIndex: currentIndex.value,
                        time: new Date().getTime()
                    }
                })
            } else if (type === 'noAnswerSubmit') {
                makeResultAnswerPartial(judgeRes)
                // 未作答日志
                writeLog({
                    log_content: {
                        label: 'noAnswerSubmit',
                        noAnswerType: noAnswerType.value,
                        dotIndex: currentIndex.value,
                        time: new Date().getTime()
                    }
                })
            }
            // console.log({
            //     event_name: '点击：互动题',
            //     event_type: 'click',
            //     page_name: 'click_interact_test',
            //     video_id: unionid.value,
            //     video_name: videoTitle.value,
            //     request_type: (dotMap?.[currentIndex.value]?.answer_type || 0) + '', // 答题类型
            //     test_type: ((dotMap?.[currentIndex.value]?.interact_question_cfg || []).map(item => item.question_type)).join(','), // 题目类型
            //     que_ids: ((dotMap?.[currentIndex.value]?.interact_question_cfg || []).map(item => item.question_id)).join(','),
            //     test_result: ((dotMap[currentIndex.value]?.interact_question_cfg || []).map(item => (judgeMap?.[item.question_id] || Array(questionsMap[item.question_id]?.queData?.normalAnswer?.length || 0).fill(-2)).join('、') || 2)).join(','),
            //     ans_duration: `${Math.round((new Date().getTime() - entryTime.value) / 1000)}`,
            //     dot_submit_time: `${new Date().getTime()}`,
            //     answer_sign: answerSign.value,
            //     no_answer_type: noAnswerType.value
            // })
            sensorsAnaticEvent('click_interact_test', {
                event_name: '点击：互动题',
                event_type: 'click',
                page_name: 'click_interact_test',
                video_id: unionid.value,
                video_name: videoTitle.value,
                request_type: (dotMap?.[currentIndex.value]?.answer_type || 0) + '', // 答题类型
                test_type: ((dotMap?.[currentIndex.value]?.interact_question_cfg || []).map(item => item.question_type)).join(','), // 题目类型
                que_ids: ((dotMap?.[currentIndex.value]?.interact_question_cfg || []).map(item => item.question_id)).join(','),
                test_result: ((dotMap[currentIndex.value]?.interact_question_cfg || []).map(item => (judgeMap?.[item.question_id] || Array(questionsMap[item.question_id]?.queData?.normalAnswer?.length || 0).fill(-2)).join('、') || 2)).join(','),
                ans_duration: `${Math.round((new Date().getTime() - entryTime.value) / 1000)}`,
                dot_submit_time: `${new Date().getTime()}`,
                answer_sign: answerSign.value,
                no_answer_type: noAnswerType.value
            })
        }
        const configPaper = () => {
            if (window['TalqsInteraction']) {
                window['TalqsInteraction'].onChange = (data) => {
                    handlePagerChange(data)
                }
            } else {
                const timer = setTimeout(() => {
                    configPaper()
                    clearTimeout(timer)
                }, 50)
            }
        }
        onMounted(() => {
            console.log('task dot mounted')
            dotWebReady()
            configPaper()
            // 注册方法接收视频打点题目信息
            // registerFnHandler("sendVideoDotInteractData", (res = {} as IInteractData) => {
            //     // console.log(res, 'sendVideoDotInteractData')
            //     setDotMap(res)
            // });
            // 注册方法接收目前要显示的是哪个点
            registerFnHandler("sendVideoDotPosition", (res = {} as IInteractPostion) => {
                currentIndex.value = ''
                writeLog({
                    log_content: {
                        label: 'sendVideoDotPosition',
                        position: res.position,
                        dotTime: res.video_dot.dot_start_time,
                        queLen: res.video_dot?.interact_question_cfg?.length,
                        time: new Date().getTime()
                    }
                })
                setDotMap(res, true)
            });
            // 手动关闭或45分钟倒计时关闭通知h5
            registerFnHandler("noSubmitClose", (res = {no_answer_type: '0'}) => {
                noAnswerType.value = res.no_answer_type
                !isAfterSubmit.value && handleSubmit('noAnswerSubmit')
            });
        })
        watch(dotUnloadedList, (val, oldVal) => {
            if (val?.length && !loadQueTimer) {
                loadQueTimer = setInterval(() => {
                    if (!dotUnloadedList.value?.length) {
                        clearInterval(loadQueTimer)
                        loadQueTimer = null
                    } else {
                        let dotIndex = dotUnloadedList.value.shift()
                        loadQue(dotMap[dotIndex].interact_question_cfg, dotIndex)
                    }
                }, 1200)
            }
        })
        return {
            loading,
            dotMap,
            currentIndex,
            handleAfterRender,
            isAfterSubmit,
            curTime,
            refQueBox,
            refCurrentBox,
            refMainCon,
            dotScrollHeight,
        }
    }
}

